// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Created: 8/14/2019, 11:27:59 AM
// Hash: -1657365624
// </auto-generated>
export enum DemographicType {
  eligibility = 1,
  alternate = 2,
}
